import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getSaleTotal, getSaleRtoVolume, getSaleRtoAmount, getSaleRtoAll, getSaleHourRevenue, getSaleDayRevenue, getSalePayRto, getSaleRank } from '@/service/sale/SaleForm';
// 销售统计
export var useSaleTotal = function useSaleTotal(params) {
  var saleTotalList = ref([]);
  // 获取销售统计
  var getSaleTotalAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSaleTotal(params.value);
          case 2:
            data = _context.sent;
            saleTotalList.value = data.list;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getSaleTotalAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [saleTotalList, getSaleTotalAsync];
};
// 料类占比销量
export var useSaleRtoVolume = function useSaleRtoVolume(params) {
  var saleRtoVolume = ref([]);
  // 料类占比销量
  var getSaleRtoVolumeAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getSaleRtoVolume(params.value);
          case 2:
            data = _context2.sent;
            saleRtoVolume.value = data.list;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getSaleRtoVolumeAsync() {
      return _ref2.apply(this, arguments);
    };
  }();
  return [saleRtoVolume, getSaleRtoVolumeAsync];
};
// 料类占比金额
export var useSaleRtoAmount = function useSaleRtoAmount(params) {
  var saleRtoAmount = ref([]);
  // 料类占比销量
  var getSaleRtoAmountAsync = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getSaleRtoAmount(params.value);
          case 2:
            data = _context3.sent;
            saleRtoAmount.value = data.list;
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function getSaleRtoAmountAsync() {
      return _ref3.apply(this, arguments);
    };
  }();
  return [saleRtoAmount, getSaleRtoAmountAsync];
};
// 料类占比查看全部
export var useSaleRtoAll = function useSaleRtoAll(params) {
  var saleRtoAll = ref({
    stone_num_data: [],
    stone_money_data: []
  });
  // 料类占比销量
  var getSaleRtoAllAsync = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var data;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getSaleRtoAll(params);
          case 2:
            data = _context4.sent;
            saleRtoAll.value = data;
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function getSaleRtoAllAsync() {
      return _ref4.apply(this, arguments);
    };
  }();
  return [saleRtoAll, getSaleRtoAllAsync];
};
// 各时间段营收趋势
export var useSaleHourRevenue = function useSaleHourRevenue(params) {
  var saleHourRevenue = ref([]);
  // 料类占比销量
  var getSaleHourRevenueAsync = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var data;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getSaleHourRevenue(params.value);
          case 2:
            data = _context5.sent;
            saleHourRevenue.value = data.list;
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function getSaleHourRevenueAsync() {
      return _ref5.apply(this, arguments);
    };
  }();
  return [saleHourRevenue, getSaleHourRevenueAsync];
};
// 各日营收趋势
export var useSaleDayRevenue = function useSaleDayRevenue(params) {
  var saleDayRevenue = ref([]);
  // 料类占比销量
  var getSaleDayRevenueAsync = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var data;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getSaleDayRevenue(params.value);
          case 2:
            data = _context6.sent;
            saleDayRevenue.value = data.list;
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function getSaleDayRevenueAsync() {
      return _ref6.apply(this, arguments);
    };
  }();
  return [saleDayRevenue, getSaleDayRevenueAsync];
};
// 支付占比
export var useSalePayRto = function useSalePayRto(params) {
  var salePayRto = ref([]);
  // 料类占比销量
  var getSalePayRtoAsync = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var data;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getSalePayRto(params.value);
          case 2:
            data = _context7.sent;
            salePayRto.value = data.list;
          case 4:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function getSalePayRtoAsync() {
      return _ref7.apply(this, arguments);
    };
  }();
  return [salePayRto, getSalePayRtoAsync];
};
// 消费排行
export var useSaleRank = function useSaleRank(params) {
  var saleRank = ref([]);
  // 料类占比销量
  var getSaleRankAsync = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var data;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return getSaleRank(params.value);
          case 2:
            data = _context8.sent;
            saleRank.value = data.list;
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function getSaleRankAsync() {
      return _ref8.apply(this, arguments);
    };
  }();
  return [saleRank, getSaleRankAsync];
};